import { Component, inject, Input } from '@angular/core';
import { AppService } from '../../services';
import { Attachment } from '../../models';
import { WorkflowAttachment, WorkflowDiscussionEntry } from '../../helpers/issue-workflow';

/**
 * The Discussion timeline of a workflow entity: one row per action taken,
 * newest first, with who acted, who it was sent to, the comment and the
 * attachments. Moved out of the punch list item detail so the issue workflow
 * shows the same thing; the host maps its lineage to `entries`.
 */
@Component({
  selector: 'app-workflow-discussion',
  templateUrl: './workflow-discussion.component.html',
  styleUrls: ['./workflow-discussion.component.scss'],
  standalone: false,
})
export class WorkflowDiscussionComponent {
  @Input() entries: WorkflowDiscussionEntry[] = [];
  @Input() emptyText = 'No activity yet.';
  /** The heading of an entry's recipients (the issue workflow says "Forwarded to"). */
  @Input() recipientsLabel = 'Sent to';

  private readonly appService = inject(AppService);

  openAttachment(event: Event, entry: WorkflowDiscussionEntry, attachment: WorkflowAttachment): void {
    this.appService.openCarousel(event, entry.attachments as Attachment[], attachment as Attachment, false);
  }
}
